import { queryOptions } from "@tanstack/react-query";
import { PUBLIC_QUERY_STALE_TIME } from "./public-query-cache";
import {
  adminGetPage,
  adminListPages,
  adminTranslationStatus,
  getLocaleReadiness,
  getPublishedPage,
  listRevisions,
} from "@/lib/content.functions";

export const localeReadinessQuery = queryOptions({
  queryKey: ["content", "readiness"],
  staleTime: PUBLIC_QUERY_STALE_TIME,
  queryFn: () => getLocaleReadiness(),
});

export const translationStatusQuery = (sleutel: string) =>
  queryOptions({
    queryKey: ["content", "translation-status", sleutel],
    queryFn: () => adminTranslationStatus({ data: { sleutel } }),
  });


export const publishedPageQuery = (sleutel: string, lang: string) =>
  queryOptions({
    queryKey: ["content", "public", sleutel, lang],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => getPublishedPage({ data: { sleutel, lang } }),
  });

export const adminPagesQuery = queryOptions({
  queryKey: ["content", "admin", "list"],
  queryFn: () => adminListPages(),
});

export const adminPageQuery = (sleutel: string, lang: string) =>
  queryOptions({
    queryKey: ["content", "admin", sleutel, lang],
    queryFn: () => adminGetPage({ data: { sleutel, lang } }),
  });

export const revisionsQuery = (pageId: string) =>
  queryOptions({
    queryKey: ["content", "revisions", pageId],
    queryFn: () => listRevisions({ data: { pageId } }),
    enabled: pageId !== "",
  });
